import {Component, forwardRef, Output, EventEmitter, Input, OnInit, AfterViewInit} from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { DynamicComponentSelectService } from './service/dynamic-component-select.service';
import { DynamicComponentGetSelectMetaInfoRequest } from './service/model/dynamicComponentGetSelectMetaInfoRequest';
@Component({
  selector: 'lc-select',
  template: `
  <nz-select [(ngModel)]="value" (ngModelChange)="change($event)"  
  nzPlaceHolder="请选择" [style.min-width]="minWidth" 
  nzShowSearch
  [nzServerSearch]="true"
  (nzOnSearch)="onSearch($event)" 
  nzAllowClear>
  <nz-option *ngFor="let o of optionList" [nzValue]="o.id" [nzLabel]="o.name"></nz-option>
  </nz-select>
  `,
  styles: [
    `
    nz-select {
      width: 100%;
    }
    .loading-icon {
      margin-right: 8px;
    }
    `
  ],
  providers:[
    DynamicComponentSelectService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LcSelectComponent),
      multi: true,
    }
  ] 
})
export class LcSelectComponent implements ControlValueAccessor,OnInit,AfterViewInit{
  id: string; // id
  set value(id:string){
      this.id=id;
  };// 值
  get value():string{
    return this.id;
  }
   
  /**
   * 模块名称
   */
  @Input()
  module:string;
  /**
   * 组件id
   */
  @Input()
  dCId:string;
  /**
   * 组件选择器
   */
  @Input()
  selector:string;
  @Input() minWidth="50px"
  @Output() c8OnChange = new EventEmitter<any>();
  private onChangeFn: (val: string) => void;
  private onTouchedFn: () => void;
  bigList: any[]=[];// 所有选项
  optionList: any[] = []; // 过滤后的选项
  constructor( private service: DynamicComponentSelectService) {

  }
  onSearch(value: string): void {
    if (value && value.length > 0) {
      this.optionList = this.bigList.filter(item => {
            return item.name.indexOf(value) > -1 || item.pin_yin && item.pin_yin.indexOf(value) > -1 || item.code && item.code.indexOf(value) > -1;
          }
      );
    } else {
      this.optionList = this.bigList;
    }
  }
  loadMore(): void {
    // 加载数据
    const request: DynamicComponentGetSelectMetaInfoRequest = {};
    request.id = this.dCId;
    request.selector = this.selector;
    this.service.getSelectMetaInfo(request,this.module, {isCache: true}).then(res => {
      if (res.data.dataSource.length > 0) {
        this.bigList = [...this.optionList, ...res.data.dataSource];
        this.optionList = this.bigList;
      }
    });
  }
  getItemById(id: string){
    const items= this.optionList.filter(f=>f.id===id);
    if(items.length>0){
      return items[0]
    } else{
      console.log(`dCId:${this.dCId} 选项未${id}找到`);
    }
  }

  ngOnInit(): void {
    // 加载数据
    this.loadMore();
  }
  ngAfterViewInit(): void {

  }
  change(value: any): void {
    this.onChangeFn(value);
    this.c8OnChange.emit(this.getItemById(value));
  }
  writeValue(value: string): void {
    this.value = value;
    console.log(this.value);
  }
  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }
}
